import moment from "moment";

/**
 * Función que calcula si un contenedor tiene demoras anticipadas
 * para realizarlo se toma la fecha de revalidación y se le resta
 * la fecha de ETA y los días libres de demoras y si el resultado
 * es menor a 0, entonces se considera que tiene demoras anticipadas
 */
export function isDemorasAnticipadas(solicitud, contenedor){
  let fechaRevalidacion = moment(solicitud.fecha_revalidacion, "YYYY-MM-DD")
  let fechaEta = moment(solicitud.fecha_eta, "YYYY-MM-DD")
  let diasLibreDemora = contenedor.dias_libre_demora
  let diffDays = fechaRevalidacion.diff(fechaEta, 'days')- diasLibreDemora
  return diffDays > 0
}
